import {defineMessages, FormattedMessage, injectIntl,} from "react-intl"
import React from "react"

const messages = defineMessages({
    requirementDefaultMessage:{
        id: "passwordRequirement.requirement_default_message",
        defaultMessage: "The password need to meet the following requirements :",
    },

    "requirement-minimum-length": {
        id:"passwordRequirement.minimum_length",
        defaultMessage: "Must contain at least 8 characters",
    },

    "requirement-uppercase": {
        id: "passwordRequirement.uppercase",
        defaultMessage: "Must contain at least one uppercase letter",
    },
    "requirement-lowercase": {
        id: "passwordRequirement.lowercase",
        defaultMessage: "Must contain at least one lowercase letter",
    },
    "requirement-number": {
        id: "passwordRequirement.number",
        defaultMessage: "Must contain at least one number",
    },

    "requirement-special-character": {
        id: "passwordRequirement.special_character",
        defaultMessage: "Must contain at least one special character (!@#$%^&*)",
    }

})

const requirementList = [
    "requirement-minimum-length",
    "requirement-uppercase",
    "requirement-lowercase",
    "requirement-number",
    "requirement-special-character"
]

const PasswordRequirementToolTip = () => {
    return (
        //TO-DO put the requirement list in a pop-up instead
        //Temporary show the requirement lists under the input field
        <div>
            {requirementList.map(requirement => {
                return (
                    <li key={requirement}>
                        <FormattedMessage{...messages[requirement]}/>
                    </li>
                )
            })}
        </div>
    )
}

export default injectIntl(PasswordRequirementToolTip)


// WEBPACK FOOTER //
// ./src/user/form/PasswordRequirementToolTip.tsx